import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { HighchartsChartModule } from 'highcharts-angular';

@Component({
  selector: 'app-epd-dashboard-charts',
  standalone: true,
  imports: [CommonModule, HighchartsChartModule],
  templateUrl: './epd-dashboard-charts.component.html',
  styleUrls: ['./epd-dashboard-charts.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class EpdDashboardChartsComponent {
  @Input() chartsData: any[] = [];
  @Input() highcharts;
}
